import { PHASE_GUIDE } from '../../lib/formulaModel';

// The phase key. Collapsed by default — it's a reference for when you're
// unsure, not something to read every time you open a formula.
export default function PhaseKey({ open = false }) {
  return (
    <details className="phase-key" open={open}>
      <summary>What do the phases mean?</summary>
      <dl>
        {PHASE_GUIDE.map((phase) => (
          <div key={phase.name}>
            <dt>{phase.name}</dt>
            <dd>
              <strong>{phase.summary}</strong>
              <span>{phase.detail}</span>
            </dd>
          </div>
        ))}
      </dl>
    </details>
  );
}
